@if (showGauge) {
  <div class="PR gauge-container card-border">
    <!--<div class="gauge-title" translate>app.core.thermo-gauge.coolant-temp</div>-->
    <div class="gauge-title" translate>{{ graphTitle }}</div>
    <div echarts [options]="option" class="gauge"></div>
  </div>
}
